import { css } from '@emotion/core';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';

export const talktousCss = css({
  position: 'fixed',
  bottom: '50px',
});

export const btnsec = css({
  maxWidth: '186px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '30px',
  justifyContent: 'flex-end',

  button: {
    cursor: 'pointer',
  },

  '.greybutton': {
    backgroundColor: '#fff',
    color: '#393939',
    outline: '#d9dbdd solid 1px',
    marginBottom: '0px',
    border: '0px',
    height: '56px',
    fontSize: '14px',
    lineHeight: '18px',
    letterSpacing: '0.875px',
    textAlign: 'center',
    textTransform: 'uppercase',

    'span:first-child': {
      paddingRight: '15px',
    },
  },

  '.redbutton': {
    backgroundColor: '#E52500',
    color: '#fff',
    border: '#E52500 solid 1px',
    marginBottom: '15px',
    height: '56px',
    fontSize: '14px',
    lineHeight: '18px',
    letterSpacing: '0.875px',
    textAlign: 'center',
    textTransform: 'uppercase',
    'span:first-child': {
      paddingRight: '15px',
    },
  },

  '.greybutton:hover, .greybutton:focus': {
    outlineColor: '#a2a2a2',
  },

  '.redbutton:hover, .redbutton:focus': {
    background: '#d42705',
    outlineColor: '#d42705',
  },
});

export const itemsContainerCss = css({
  marginTop: 10,
  width: '100% !important',
  display: 'flex',
  justifyContent: 'flex-end',
  flexWrap: 'wrap',

  p: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    maxWidth: '224px',
    letterSpacing: '0px',
    textAlign: 'right',
    marginBottom: '40px',
  },

  [MediaQueries.sm]: {
    paddingRight: '15px',
    marginTop: 64,
  },
  [MediaQueries.xs]: {
    marginTop: '20px',
  },

  [MediaQueries.md]: {
    marginTop: 64,
  },
  [MediaQueries.lgAndUp]: {
    marginTop: 64,
  },

  a: { color: '#393939', textDecoration: 'none' },
  h2: {
    marginBottom: '32px',
    fontWeight: '500',
    fontSize: '34px',
    lineHeight: '40px',
  },

  h3: {
    fontSize: '14px',
    lineHeight: '24px',
    letterSpacing: '0px',
    fontWeight: '500',
    marginBottom: '5px',
    textAlign: 'right',
    color: '#008385',
  },

  li: {
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '32px',
    letterSpacing: '0px',
    textAlign: 'right',
    marginBottom: '24px',

    img: {
      marginLeft: '15px',
      position: 'relative',
      top: '2px',
    },
  },
});

export const itemTextCss = css(typography.effra40, {
  color: 'inherit',
  pointerEvents: 'none',
  fontWeight: fontWeights.light,
  position: 'relative',
  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: -2,
    left: 0,
    width: '100%',
    height: 1,
    borderBottom: `1px solid ${colorsPalette.grey90}`,
  },
});

export const activeTextCss = css({
  '&:after': {
    borderBottom: `1px solid ${colorsPalette.grey50}`,
  },
});

export const activeItemCss = css({
  color: colorsPalette.white,
});

export const itemCss = css({
  marginBottom: 16,
  [MediaQueries.md]: {
    marginBottom: 29,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 27,
  },
});

export const buttonCss = css({
  cursor: 'pointer',
  color: colorsPalette.grey50,
  '&:hover': {
    color: colorsPalette.white,
  },
});

export const titleCss = css(typography.effra40, {
  color: colorsPalette.grey40,
  fontWeight: fontWeights.light,
  [MediaQueries.lg]: {
    marginBottom: 24,
  },
  [MediaQueries.xl]: {
    marginBottom: 32,
  },
});

export const descriptionCss = css(typography.effra18, {
  color: colorsPalette.grey20,
  [MediaQueries.lg]: {
    marginBottom: 32,
  },
  [MediaQueries.xl]: {
    marginBottom: 40,
  },
});

export const bottomLinksCss = css({
  alignItems: 'flex-end',
  bottom: 57,
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  right: 0,

  button: {
    borderBottom: '1px solid #656566',
    paddingLeft: '0',
  },

  a: {
    borderBottom: '1px solid #656566',
  },

  h4: {
    marginBottom: '8px',
  },
  [MediaQueries.md]: {
    bottom: 65,
  },
  [MediaQueries.lg]: {
    textAlign: 'right',
  },
});

export const linkStyleCss = css(typography.effra16, {
  border: 'none',
  backgroundColor: 'transparent',
  paddingRight: '0px',
  cursor: 'pointer',
  marginBottom: '10px',
  borderBottom: `1px solid ${colorsPalette.transparent}`,
  color: colorsPalette.white,
  textAlign: 'end',
  textDecoration: 'none',
  '&:hover': {
    borderColor: colorsPalette.grey90,
  },
});

export const bottomRightLink1Css = css({
  marginBottom: 8,
});

export const verticalLineCss = css({
  position: 'absolute',
  width: 1,
  height: '100%',
  top: 0,
  left: '36%',
  borderLeft: `1px solid ${colorsPalette.white}`,
  opacity: 0.05,
});

export const phoneNumberCss = css(typography.effra28, {
  display: 'flex',
  alignItems: 'center',
  fontSize: '14px',
  a: { fontSize: '16px', display: 'flex', alignItems: 'center' },
  '.cust-call-no': {
    paddingRight: '10px',
    position: 'relative',
    top: '2px',
  },

  '.cust-call-us': {
    color: '#393939',
    fontWeight: 500,
    margin: '0 16px 0 0px',
  },

  [MediaQueries.mdAndUp]: {
    ...typography.effra34,
  },
  '.phone-container': {
    color: colorsPalette.white,
  },
  '.phone-label': {
    display: 'none',
  },
  '.phone-alternate-icon': {
    fontSize: 17,
    color: colorsPalette.red,
    lineHeight: '42px',
    marginRight: 10,
  },
  '.phone-number': {
    position: 'relative',
    '::after': {
      content: '""',
      position: 'absolute',
      left: 0,
      bottom: 0,
      backgroundColor: colorsPalette.grey90,
      height: 1,
      width: '100%',
    },
  },
});
